import { Grid } from "./Components/Grid";

export const DashboardsPage = () => {
  return <Grid />;
};
